import { getGradientsOverride } from '../components/gradients/index.js';
var mapOverrideTokens = themeOverride => {
  var {
    palette
  } = themeOverride;
  return {
    colors: {
      reds: palette == null ? void 0 : palette.error,
      greens: palette == null ? void 0 : palette.success,
      yellows: palette == null ? void 0 : palette.warning,
      oranges: palette == null ? void 0 : palette.secondary,
      ultraViolets: palette == null ? void 0 : palette.primary,
      blues: palette == null ? void 0 : palette.informational,
      greys: palette == null ? void 0 : palette.greys
    },
    gradients: getGradientsOverride(palette == null ? void 0 : palette.gradients)
  };
};
export { mapOverrideTokens };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
